/**
 * 移出考题本
 */

import { fetchData } from '@umu/umu-fetch';
import Api from '../../../../path';

export interface IInput {
    element_id: number;
    question_id?: number;
}

export interface IOutput {
    status: number;
}

export const removeFromQuestionCollection = (data: IInput): Promise<IOutput> => {
    return fetchData(Api.QUESTION_COLLECTION_DEL, data).then((res: IResponse<IOutput>) => {
        return res.data;
    });
};
